module.exports = __webpack_public_path__ + "static/media/5ed79c1872f4e5e57a748785.7a290647.png";